import React from 'react';
import { Link } from 'react-router-dom';

import { Separator } from './components/separator';

import './breadcrumb.scss';

export interface IRoute {
    path?: string; // 前端 history 路由
    href?: string; // a 标签跳转链接
    name: string;
    itemRender?(item: IRoute, isCurrent: boolean): JSX.Element; // 自定义渲染
}

export interface IProps {
    routes: IRoute[];
    className?: string;
    separator?: JSX.Element | string; // 分割符
    itemRender?(item: IRoute, isCurrent: boolean): JSX.Element; // 自定义渲染
}

/**
 * 面包屑导航
 * @author Kody
 */
export const Breadcrumb = (props: IProps) => {
    const { routes, separator, itemRender } = props;

    const renderItem = (item: IRoute, isCurrent: boolean) => {
        if (typeof itemRender === 'function') {
            return itemRender(item, isCurrent);
        } else if (typeof item.itemRender === 'function') {
            return item.itemRender(item, isCurrent);
        }
        else if (isCurrent || (!item.path && !item.href)) {
            return (
                <span className={`breadcrumb-item ${isCurrent ? 'current' : ''}`}>
                    {item.name}
                </span>
            );
        } else if (item.path) {
            return <Link to={item.path} className="breadcrumb-item">{item.name}</Link>;
        } else {
            return <a href={item.href} className="breadcrumb-item">{item.name}</a>
        }
    };

    const renderItems = () => {
        return routes.map((item: IRoute, i: number) => {
            const isCurrent = i === routes.length - 1;
            if (i === 0) {
                return <li key={i}>{renderItem(item, isCurrent)}</li>;
            }
            return (
                <li key={i}>
                    <Separator separator={separator} />
                    {renderItem(item, isCurrent)}
                </li>
            );
        });
    };

    const render = () => {
        return (
            <div className="umu-breadcrumb">
                <ul>
                    {renderItems()}
                </ul>
            </div>
        );
    };
    return render();
};
